type ShareLink = {
  icon: string
  label: string
  url: string
}

export function stripEndingSlash(path: string) {
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1)
  }

  return path
}

const sharePlatforms = [
  {
    id: 'facebook',
    label: 'Facebook share',
    icon: 'Facebook',
    urlBase: 'https://www.facebook.com/sharer/sharer.php?u='
  },
  {
    id: 'twitter',
    label: 'Twitter Share',
    icon: 'Twitter',
    urlBase: 'https://twitter.com/intent/tweet?url='
  },
  {
    id: 'linkedin',
    label: 'LinkedIn Share',
    icon: 'Linkedin',
    urlBase: 'https://www.linkedin.com/sharing/share-offsite/?url='
  }
]

export default function getShareLinks(url: string): ShareLink[] {
  const commonShareUrlParams = {
    url,
    source: 'social',
    campaign: 'o7web_share'
  }

  return sharePlatforms.map<ShareLink>(sharePlatform => {
    return {
      label: sharePlatform.label,
      icon: sharePlatform.icon,
      // This does not work as expected for LinkedIn because they strip the encoded URL's query string params
      url: `${sharePlatform.urlBase}${encodeURIComponent(
        applyUTMParameters({
          ...commonShareUrlParams,
          medium: sharePlatform.id
        })
      )}`
    }
  })
}

export function applyUTMParameters({
  url,
  source,
  medium,
  campaign
}: {
  url: string
  source?: string
  medium?: string
  campaign?: string
}) {
  const newUrl = new URL(url)
  newUrl.searchParams.set('utm_source', source)
  newUrl.searchParams.set('utm_medium', medium)
  newUrl.searchParams.set('utm_campaign', campaign)
  return newUrl.toString()
}
